import { render } from "./Heading4.vue?vue&type=template&id=80f39ef4&ts=true"
import script from "./Heading4.vue?vue&type=script&lang=ts"
export * from "./Heading4.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Karol\\Documents\\Github\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__